export const CONTACT_EMAIL = 'support@cirrusoft.com';

export const CONTACT_PHONE = '+41 41 289 05 05';
